import {Types} from "@Common/types";

import {buildUrlQuery} from "../../utils/build-url-query";
import {mapValues}     from "../../utils/objects";

import {LocationApis} from "./location-apis";

export const BaseApis = ({fetcher}) => ({
    getCountryCodes: (): Promise<Types.Apis.Payloads.Next.CountryCode.GetCountryCodes.Response> => fetcher.getJson(`/next-api/countrycode/get_country_codes`),
    getBranchList: async ({
        activeOfficesOnly = false,
        filterByUserLevel = true,
        companyXdocsUrl = '',
    }:Types.Apis.Payloads.Next.Branch.GetAll.Request = {}): Promise<Types.Apis.Payloads.Next.Branch.GetAll.Response> => {
        const query = buildUrlQuery({...mapValues({activeOfficesOnly, filterByUserLevel}, v => Number(v)), companyXdocsUrl});
        return fetcher.getJson(`/next-api/branch/all${query}`);
    },
    getDefaultOffices: async () => fetcher.getJson(`/next-api/branch/getDefaultOffices`),
    getAgentList: async (branchId:string='', filterByUserLevel:1|0=1, limitByBenefit=''): Promise<Types.Apis.Payloads.Next.Agent.GetAll.Response> => (
        fetcher.getJson(`/next-api/agent/all${branchId ? `/${branchId}`: ''}?filterByUserLevel=${encodeURIComponent(filterByUserLevel)}${limitByBenefit? `&limitByBenefit=${limitByBenefit}`: ''}`)
    ),
    getAllAgentList: async (): Promise<Types.Apis.Payloads.Next.Agent.GetAll.Response> => (
        fetcher.getJson(`/next-api/agent/all`)
    ),

    // @deprecated use next.session.getAgent({agentId}) instead
    getAgentById: (idAgent='') => fetcher.getJson(`/next-api/agent/get-agent?idAgent=${encodeURIComponent(idAgent)}`),

    // @deprecated use next.session.getBranch({officeId}) instead
    getBranchById: (idBranch:string=''): Promise<Types.Apis.Payloads.Next.Branch.GetById.Response> => (
        fetcher.getJson(`/next-api/branch/get-branch?idBranch=${encodeURIComponent(idBranch)}`)
    ),

    getHolidays: async () => (await fetcher.getJson("/next-api/holidays/get")).holidays,

    location: LocationApis({fetcher}),
});

